const initialState = {};

const contractReducer = (state = initialState, action) => {
  const isCCA_User = action.payload?.isCCAUser || false;
  switch (action.type) {
    case 'STORE_CONTRACTS': {
      let isVirtualContract = false;
      if (isCCA_User) {
        isVirtualContract = action.payload.contracts?.some(
          (contract) => contract.isVirtualContract == 1,
        );
      }
      return {
        ...state,
        isVirtualContract: isVirtualContract,
        contracts: isVirtualContract
          ? action.payload.contracts?.filter(
              (contract) => contract.isVirtualContract == 1,
            )
          : action.payload.contracts,
      };
    }
    default:
      return state;
  }
};
export default contractReducer;
